import { Textarea, TextareaProps, useMergeRefs } from '@chakra-ui/react';
import { rem } from 'polished';
import { ChangeEvent, forwardRef, useEffect, useRef } from 'react';
import { useWindowSize } from 'react-use';

export const TextareaAutogrow = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ onChange, ...props }, ref) => {
    const { width } = useWindowSize();
    const inputRef = useRef<HTMLTextAreaElement>(null);
    const refs = useMergeRefs(inputRef, ref);

    const handleChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
      onChange?.(e);
      if (!inputRef.current) return;
      inputRef.current.style.height = rem(80);
      inputRef.current.style.height = rem(e.target.scrollHeight);
    };

    useEffect(() => {
      if (!inputRef.current) return;
      inputRef.current.style.height = rem(inputRef.current.scrollHeight);
    }, [width, inputRef, props.value]);

    return (
      <Textarea
        ref={refs}
        onChange={handleChange}
        resize="none"
        overflow="hidden"
        h="unset"
        minH={rem(props.rows ? props.rows * 28 : 120)}
        {...props}
      />
    );
  },
);
